module.exports = __webpack_public_path__ + "img/73.13f67bb0.jpg";